exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-content[data-v-6e1cc67d] {\n  height: 60vh;\n  overflow-y: auto;\n}\n.product[data-v-6e1cc67d] {\n  font-style: italic;\n}\n.category[data-v-6e1cc67d] {\n  font-weight: bold;\n}\n.hideCheckbox[data-v-6e1cc67d] {\n  background-color: white;\n  height: 20px;\n  width: 20px;\n  margin-left: -22px;\n}\n", ""]);

// exports
